import React, { useContext } from "react";

import { Layout, Select } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { MenuPrincipal } from "./components/MenuPrincipal";
import { MenuPerfil } from "./components/MenuPerfil";
import { SecurityContext } from "../../context/SecurityContextProvider";
import { useState } from "react";
import { useEffect } from "react";
import { DownOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import AppConfigService from "../../services/AppConfigService";

const { Header, Content, Footer } = Layout;

const { Option } = Select;

export function PlantillaWeb({ children }) {
  const {
    // getOpciones,
    // getEmpresas,
    getUsuarioAutenticado,
    // getEmpresaFavorita,
    setEmpresaSeleccionada,
  } = useContext(SecurityContext);

  const [opciones, setOpciones] = useState(null);
  const [urlImagenLogotipo, setUrlImagenLogotipo] = useState("");
  const [mensajeFlotante, setMensajeFlotante] = useState(null);
  const [empresaKey, setEmpresaKey] = useState(getUsuarioAutenticado().empresaSeleccionada.id);

  let history = useHistory();

  useEffect(() => {
    const opcionesEmpresaSeleccionada = getUsuarioAutenticado().empresaSeleccionada.opciones;
    setOpciones(opcionesEmpresaSeleccionada);
    setUrlImagenLogotipo(getUsuarioAutenticado().empresaSeleccionada.urlImagenLogotipo);

    const cargarMensajeFlotante = async () => {
      try {
        const config = await AppConfigService.obtenerMensajeFlotante();
        if (config?.activo && config?.mensaje) {
          setMensajeFlotante(config.mensaje);
        }
      } catch (e) {
        // silencioso
      }
    };
    cargarMensajeFlotante();
  }, []);

  function handleOnChangeEmpresa(idEmpresa) {
    setEmpresaSeleccionada(idEmpresa);
    setOpciones(getUsuarioAutenticado().empresaSeleccionada.opciones);
    setUrlImagenLogotipo(getUsuarioAutenticado().empresaSeleccionada.urlImagenLogotipo);
    setEmpresaKey(idEmpresa);
    history.push("/dashboard");
  }
  function handleOnClickLogo() {
    history.push("/dashboard");
  }

  return (
    <Layout className="layout">
      <Header />
      <Header className="layout-header">
        <div>
          <a onClick={handleOnClickLogo}>
            <img
              className="layout-header__logotipo-imagen"
              src={urlImagenLogotipo ? urlImagenLogotipo : ""}
              alt="logo"
            />
          </a>
        </div>
        <div className="layout-header__logotipo">
          <Select
            className="texto-menu-perfil"
            suffixIcon={<DownOutlined style={{ color: "#1678c1" }} />}
            defaultValue={getUsuarioAutenticado().empresaSeleccionada.id}
            bordered={false}
            dropdownMatchSelectWidth={false}
            onChange={handleOnChangeEmpresa}
          >
            {getUsuarioAutenticado().empresas.map((empresa) => (
              <Option key={empresa.id} value={empresa.id}>
                {empresa.razonSocial}
              </Option>
            ))}
          </Select>
        </div>
        <div className="layout-header__menu">
          <MenuPrincipal opciones={opciones} />
        </div>
        <div className="layout-header__menu-perfil">
          <MenuPerfil />
        </div>
      </Header>
      {mensajeFlotante && (
        <div style={{
          background: "linear-gradient(90deg, #ff7875 0%, #ff4d4f 100%)",
          padding: "10px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          boxShadow: "0 2px 6px rgba(255,77,79,0.3)",
        }}>
          <ExclamationCircleFilled style={{ color: "#fff", fontSize: "16px", flexShrink: 0 }} />
          <span style={{ color: "#fff", fontWeight: "600", fontSize: "13px", textAlign: "center" }}>
            {mensajeFlotante}
          </span>
        </div>
      )}
      <Content className="layout-content" key={empresaKey}>{children}</Content>
      {/* <Footer className="layout-footer">InGenio Technologies ©2020</Footer> */}
    </Layout>
  );
}
